import { render, staticRenderFns } from "./CitizenshipApplicationView.vue?vue&type=template&id=4290f4e9&scoped=true"
import script from "./CitizenshipApplicationView.vue?vue&type=script&lang=js"
export * from "./CitizenshipApplicationView.vue?vue&type=script&lang=js"
import style0 from "./CitizenshipApplicationView.vue?vue&type=style&index=0&id=4290f4e9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4290f4e9",
  null
  
)

export default component.exports